// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/communication/web_channel/v1/web_channel.proto (package stailer_service_specification.communication.web_channel.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/communication/web_channel/v1/web_channel.proto.
 */
const file_stailer_service_specification_communication_web_channel_v1_web_channel = /*@__PURE__*/
  fileDesc("CkxzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jb21tdW5pY2F0aW9uL3dlYl9jaGFubmVsL3YxL3dlYl9jaGFubmVsLnByb3RvEjpzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jb21tdW5pY2F0aW9uLndlYl9jaGFubmVsLnYxIsgCCgpXZWJDaGFubmVsEmwKDXdlYl9jb3B5cmlnaHQYASABKAlCVZKCGTPjgYrlrqLmp5h3ZWLjgafooajnpLrjgZnjgovokZfkvZzmqKnmg4XloLHjgafjgZnjgIKqghkSV2Vi6JGX5L2c5qip5oOF5aCxuIIZA8CCGQESdgoRd2ViX3NlcnZpY2VfaG9zdHMYAiADKAlCW5KCGTPjgYrlrqLmp5h3ZWLjgpLmj5DkvpvjgZnjgovjg5vjgrnjg4jkuIDopqfjgafjgZnjgIKqghkYV2Vi44K144O844OT44K544Ob44K544OIuIIZA8CCGQESVAoJd2ViX3RpdGxlGAMgASgJQkGSghki44GK5a6i5qeYd2Vi44GubWV0YSB0aXRsZeOBp+OBmeOAgqqCGQ9XZWLjgr/jgqTjg4jjg6u4ghkDwIIZAWIGcHJvdG8z", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.communication.web_channel.v1.WebChannel.
 * Use `create(WebChannelSchema)` to create a new message.
 */
const WebChannelSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_communication_web_channel_v1_web_channel, 0);


exports.file_stailer_service_specification_communication_web_channel_v1_web_channel = file_stailer_service_specification_communication_web_channel_v1_web_channel;
exports.WebChannelSchema = WebChannelSchema;
